import {IS_IFRAME} from '../../constants/environment'
import {DEFAULT_IFRAME_HEIGHT} from '../../constants/layout'

export default function({style}) {
  if (!IS_IFRAME) return {style}
  
  const replaceVH = (match, number, unit, offset, string) => {
    const fixed = Number(number) * (DEFAULT_IFRAME_HEIGHT / 100)
    return `${fixed}px`
  }
  const replaceStyles = (style) => {
    // Somehow in iframe we have an error with this style equal to null
    // So we added this condition below for checking the style
    const cloneStyle = style || {}
    return Object.keys(cloneStyle).reduce((newStyle, key) => {
      let value = cloneStyle[key]
      const matchVH = /(\d+)(vh)/i
      if (typeof value === 'object') {
        value = replaceStyles(value)
      } else if (typeof value === 'string') {
        value = value.replace(matchVH, replaceVH)
      }
      newStyle[key] = value
      return newStyle
    }, {})
  }
  const rs = replaceStyles(style)
  return {style: rs}
}



// WEBPACK FOOTER //
// ./src/higher-order-components/configured-radium/vh-px-plugin.js